export const dataKuliner = [
  {
    id: 1,
    content_type: "kuliner",
    name: "Teh Daun Kelor",
    mini_description: "Teh yang terbuat dari daun kelor dan telah dikemas menjadi teh celup",
    image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1676293870/banraas%2C%20gili-iyang/data_kuliner/Rectangle_33_hwqxnl.jpg",
  },
  {
    id: 2,
    content_type: "kuliner",
    name: "Cengkaruk",
    mini_description: "Makanan yang terbuat dari nasi kering dengan berbagai rasa",
    image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1676293854/banraas%2C%20gili-iyang/data_kuliner/Rectangle_33_nfhiwv.jpg",
  },
  {
    id: 3,
    content_type: "kuliner",
    name: "Teh Telang",
    mini_description: "Teh yang terbuat dari bahan daun Pohon Telang",
    image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1676293965/banraas%2C%20gili-iyang/Rectangle_33_asmu3b.jpg",
  },
  {
    id: 4,
    content_type: "kuliner",
    name: "Krupuk Khas Gili Iyang",
    mini_description: "Krupuk yang dibuat asli dari pulau gili iyang",
    image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1676293965/banraas%2C%20gili-iyang/Rectangle_33_asmu3b.jpg",
  },
];
